export default __webpack_public_path__ + "static/media/gp-img.d620df02.webp";